module.exports = __webpack_public_path__ + "img/skiing2.3404268e.jpg";